import React from 'react';

const LoginFieldError = ({ message, id }) => {
  if (!message) return null;

  return (
    <div className='login-field-error' role='alert' id={id}>
      <i className='ri-error-warning-line' aria-hidden='true' />
      <span>{message}</span>
    </div>
  );
};

export default LoginFieldError;
